import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  title: {
    textAlign: 'center',
    '& h2': {
      fontSize: 16,
    },
  },
  message: {
    fontSize: 14,
    marginBottom: 0,
    whiteSpace: 'pre-line',
  },
  button: {
    color: theme.palette.colors.readerPrimaryColor,
    border: `0.5px solid ${theme.palette.colors.readerPrimaryColor}`,
  },
}));

export default useStyles;
